import { NgModule } from "@angular/core";
import { c_subscriber_state_changes_component } from "./c_subscriber_state_changes_component";

@NgModule({
  declarations: [c_subscriber_state_changes_component],
  exports: [c_subscriber_state_changes_component],
})
export class c_subscriber_state_changes_module {}
